/* ZEEKSTAR — quiet reveal.
   One IntersectionObserver, unobserved after firing. Skipped entirely when
   the visitor has asked for reduced motion, so it costs nothing there. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Opt the document in only once we know we can finish the job. Until this
  // class lands, .zk-reveal content renders normally — so a blocked or broken
  // script can never leave the storefront blank.
  var root = document.documentElement;
  root.classList.add('zk-reveal-ready');

  var showAll = function () {
    document.querySelectorAll('.zk-reveal:not(.is-in)').forEach(function (el) {
      el.classList.add('is-in');
    });
  };

  // Last line of defence: whatever happens with observers or layout, nothing
  // stays invisible for more than a moment.
  var safety = setTimeout(showAll, 2500);

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  var scan = function (scope) {
    var items = (scope || document).querySelectorAll('.zk-reveal:not(.is-in)');
    if (!items.length) return;
    clearTimeout(safety);
    safety = setTimeout(showAll, 2500);
    items.forEach(function (el) { observer.observe(el); });
  };

  // The script is deferred, so the DOM is already parsed — scan now rather
  // than waiting on an event that may have fired.
  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  }
  // The Theme Editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
